import * as React from 'react';
import { Section } from '../../../components/Section';
import { EScrollingBlocks } from '../../../constants/scrollingBlocks';
import { MobileInfrastructureContainerLoad } from '../../InfrastructureMapContainer';
import { MarketPriceContainer } from '../../MarketPriceContainer';
import { ObjectInfoContainer } from '../../ObjectInfoContainer';
import { OffersHistoryContainer } from '../../OfferHistory/Mobile';
import { RateOurEstimationContainer } from '../../RateOurEstimationContainer';
import { useScrollingRef } from '../../Scrolling';
import { ValuationContentContainer } from '../../ValuationContentContainer';
import { ValuationFiltersContainer } from '../../ValuationFiltersContainer';
import { useSelector } from 'react-redux';
import { selectIsAgent } from '../../../selectors/user';
import { RateSuburbanContainer } from '../../RateSuburbanContainer';
import { selectIsFromOfferCard } from '../../../selectors/page';
import { MyHomeMigrationBannerContainer } from '../../MyHomeMigrationBannerContainer';

export const MobileViewContainer: React.FC = () => {
  const valuationFiltersRef = useScrollingRef(EScrollingBlocks.ValuationFilters);
  const marketPriceRef = useScrollingRef(EScrollingBlocks.MarketPrice);
  const offersHistoryRef = useScrollingRef(EScrollingBlocks.OffersHistory);
  const infrastructureRef = useScrollingRef(EScrollingBlocks.Infrastructure);
  const objectInfoRef = useScrollingRef(EScrollingBlocks.ObjectInfo);

  const isAgent = useSelector(selectIsAgent);
  const isFromOfferCard = useSelector(selectIsFromOfferCard);

  return (
    <>
      <ValuationFiltersContainer refWrapper={valuationFiltersRef} />
      <ValuationContentContainer>
        <Section marginTop={32}>
          <ObjectInfoContainer refWrapper={objectInfoRef} />
        </Section>
        <Section>
          <MyHomeMigrationBannerContainer />
        </Section>
        <Section marginBottom={48}>
          <MarketPriceContainer refWrapper={marketPriceRef} />
          <RateOurEstimationContainer />
        </Section>
        {isFromOfferCard && !isAgent && (
          <Section marginBottom={48}>
            <RateSuburbanContainer />
          </Section>
        )}
        <Section marginBottom={48}>
          <OffersHistoryContainer refWrapper={offersHistoryRef} />
        </Section>
        <Section marginBottom={48}>
          <MobileInfrastructureContainerLoad refWrapper={infrastructureRef} />
        </Section>
      </ValuationContentContainer>
    </>
  );
};

MobileViewContainer.displayName = 'MobileView';
